export default __webpack_public_path__ + "static/media/csc_02.c3f0d2ca.png";